import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAdminAuth } from '@/contexts/AdminAuthContext'

type Props = {
  children: React.ReactNode
  permission?: string
  role?: string
  fallbackPath?: string
}

const AdminRouteGuard: React.FC<Props> = ({ children, permission, role, fallbackPath = '/unauthorized' }) => {
  const { hasPermission, hasRole } = useAdminAuth()

  if (permission && !hasPermission(permission)) {
    return <Navigate to={fallbackPath} replace />
  }
  if (role && !hasRole(role)) {
    return <Navigate to={fallbackPath} replace />
  }
  return <>{children}</>
}

export default AdminRouteGuard


